import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay, finalize } from 'rxjs';
import { AuthorizationService as AUTHORIZATION, FeUtil, BeUtil } from "../../../hezky-routes";

@Injectable({
  providedIn: 'root'
})
@UntilDestroy({ checkProperties: true })
export class DeepLinkingService {
  public isLoading: boolean = true;
  constructor(private feUtil: FeUtil, private beUtil: BeUtil, private authorization: AUTHORIZATION) { }

  handleQueryParams(params: any) {
    if (this.authorization.isAuthenticated()) {
      this.makeApiAndRouterCalls(params);
    } else {
      this.feUtil.router.navigate(['auth/login'], { queryParams: params });
      this.feUtil.message.error('Please login to continue', { nzDuration: 3000 });
    };
  }

  private makeApiAndRouterCalls(params: any) {
    switch (params.t) {
      case 'schedule_report':
        this.routeToScheduleReport(params);
        break;
      case 'incident':
        this.routeToIncidentReport(params);
        break;
      default:
        break;
    }
  }

  private routeToScheduleReport(params: any) {
    this.isLoading = true;
    let payload = { scope: 'my-reports' };
    this.beUtil.reportSvc.fetchReports(payload)
      .pipe(
        untilDestroyed(this),
        delay(1000),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: ({ status, data }) => {
          if (status !== 200) {
            this.feUtil.router.navigate(['/reports/report-management']);
            return;
          }
          let { report_list } = data;
          if (Array.isArray(report_list) && report_list?.length > 0) {
            let schedule_report = report_list.find((report: any) => report?.report_id == params?.d);
            if (schedule_report) {
              this.beUtil.reportSvc.viewReportHandler(schedule_report);
            } else {
              this.feUtil.message.error('Report not found! Please try again later.', { nzDuration: 3000 });
              this.feUtil.router.navigate(['/reports/report-management']);
            }
          }
        }
      })
  }

  private routeToIncidentReport(params: any) {
    const id = params?.d;
    if (id.startsWith('T')) {
      let leg_id = id.split('L')[1];
      this.feUtil.router.navigate(['transport-incidents/list/', leg_id]);
    } else {
      this.feUtil.router.navigate(['storage-incidents/list/', id]);
    }
  }
}
